// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { MessageCircle } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMessageCircle(props: any) {
    return <IconBase icon={MessageCircle} {...props} />
  }

  export default IconMessageCircle
  